import { DateTime } from "luxon";

// Equation of Time (approximate formula, returns minutes)
function getEquationOfTime(date) {
  const dayOfYear = date.ordinal;
  const B = (360 / 365) * (dayOfYear - 81) * (Math.PI / 180);
  const EoT = 9.87 * Math.sin(2 * B) - 7.53 * Math.cos(B) - 1.5 * Math.sin(B);
  return EoT; // in minutes
}

/**
 * Compute true solar time
 * @param {string} date - YYYY-MM-DD
 * @param {number} hour - local hour (0–23)
 * @param {number} minute - local minute (0–59)
 * @param {number} longitude - in degrees
 * @param {string} timeZone - IANA zone (e.g., "Asia/Shanghai")
 * @returns {DateTime} Luxon DateTime representing true solar time
 */
export function computeTrueSolarTime(date, hour, minute, longitude, timeZone) {

  // Construct local time in user's time zone
  const localTime = DateTime.fromObject(
    { year: parseInt(date.slice(0, 4)), month: parseInt(date.slice(5, 7)), day: parseInt(date.slice(8, 10)), hour, minute },
    { zone: timeZone }
  );

  const eotMinutes = getEquationOfTime(localTime); // Equation of Time
  const standardMeridian = Math.round(localTime.offset / 60) * 15; // degrees
  const longitudeCorrection = 4 * (longitude - standardMeridian); // minutes
  const totalCorrection = longitudeCorrection + eotMinutes;

  // Apply correction to get true solar time
  const trueSolarTime = localTime.plus({ minutes: totalCorrection });

  return trueSolarTime;
}